var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWind(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 430.14 383.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #344c60;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 15px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m144.95,73.79c0-36.61,29.68-66.29,66.29-66.29s66.29,29.68,66.29,66.29-29.68,66.29-66.29,66.29H38.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m306.92,116.52c0-31.95,25.9-57.86,57.86-57.86s57.86,25.9,57.86,57.86-25.9,57.86-57.86,57.86H14.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m240.98,309.25c0,36.61,29.68,66.29,66.29,66.29s66.29-29.68,66.29-66.29-29.68-66.29-66.29-66.29H78.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 236.58,
    y1: 208.67,
    x2: 7.5,
    y2: 208.67
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind);
export default __webpack_public_path__ + "static/media/wind.c3d93ef35d88d2df4e3aa0a0232127c1.svg";
export { ForwardRef as ReactComponent };